<style lang="less">
    @import './main.less';
</style>
<template>
    <div class="main" :class="{'main-hide-text': shrink}" ref="mainBody">
        <div class="sidebar-menu-con" :style="{width: shrink?'60px':'200px', overflow: shrink ? 'visible' : 'auto'}">
            <div class="layout-logo"><img style="height:40px" src="../assets/logo.png" key="max-logo" />
                <span class="bate">Bate.v1.0</span>
            </div>
            <CpMenu ref="cpMenu" :before-push="beforePush" :open-names="openedSubmenuArr" :menu-list="menuList" />
            <div style="width:200px;position: fixed;padding: 5px;bottom: 0px;left: 0px;text-align: center;">
                <a style="font-size: 16px;" target="_blank" href="https://www.taobao.com/markets/cnwww/print">菜鸟打印控件下载</a>
            </div>
        </div>
        <div class="main-header-con" :style="{paddingLeft: shrink?'60px':'200px'}">
            <div class="main-header">
                <!--  <div class="navicon-con">
                    <i class="md-arrow-back" size="32" :style="{lineHeight:'40px',transform: 'rotateZ(' + (this.shrink ? '-180' : '0') + 'deg)'}" @click="toggleClick" />
                </div> -->
                <div class="header-middle-con">
                    <TopMenu />
                </div>
            </div>
            <div style="position: relative;">
                <custom-breadcrumb :currentPath="currentPath">
                </custom-breadcrumb>
                <div style="position: absolute;right: 0px;top:6px;bottom: 0px">
                    <el-button size="small" type="primary" @click="waybillExpressGo" class="optButton">包裹签收
                        <i class="md-add-circle" size="18" /></el-button>
                    <el-button size="small" type="success" @click="waybillGo" class="optButton">订单出库
                        <i class="md-add-circle" size="18" /></el-button>
                    <el-button size="small" type="warning" @click="waybillLocalGo" class="optButton">本土货代交接出库
                        <i class="md-add-circle" size="18" /></el-button>
                    <el-button size="small" type="danger" @click="waybillLocalSignGo" class="optButton">本土货代到货签收
                        <i class="md-add-circle" size="18" /></el-button>
 <el-button size="small" type="primary" @click="BillSign" class="optButton">入库签收
                        <i class="md-add-circle" size="18" /></el-button>

                </div>
            </div>
            <div class="tags-con">
                <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
            </div>
        </div>
        <div class="single-page-con" :style="{left: shrink?'60px':'200px'}">
            <div class="single-page" style="margin-bottom: 50px;">
                <keep-alive :include="cachePage">
                    <router-view></router-view>
                </keep-alive>
                <div style="padding:10px;font-size:14px;position: fixed;bottom: 5px;left: 200px;right: 200px;text-align: center;">福建泉州市鲲鹏科技有限公司,版权所有 <a href="http://wei9ba.com/" target="_blank">万正lazada助手</a></div>
            </div>
        </div>
    </div>
</template>
<script>
import CpMenu from '../Menu.vue'
import TopMenu from '../TopMenu.vue'
import util from "@/utils/util"
import TagsPageOpened from '@/components/Nav/TagsPageOpened.vue'
import CustomBreadcrumb from '@/components/Nav/CustomBreadcrumb.vue'
export default {
    name: "Main",
    data() {
        return {

            shrink: false,
            avatorPath: '',
            interval: null,
            openedSubmenuArr: this.$store.state.app.openedSubmenuArr
        };
    },
    components: {
        CpMenu,
        TopMenu,
        TagsPageOpened,
        CustomBreadcrumb
    },

    computed: {
        
       
        menuList() {
            return this.$store.state.app.menuList;
        },
        pageTagsList() {
            return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
        },


        currentPath() {
            return this.$store.state.app.currentPath; // 当前面包屑数组
        },

        cachePage() {
            return this.$store.state.app.cachePage;
        },
        lang() {
            return this.$store.state.app.lang;
        },
        menuTheme() {
            return this.$store.state.app.menuTheme;
        },
        mesCount() {
            return this.$store.state.app.messageCount;
        }
    },

    mounted: function() {

        var me = this;
        //去取信息提交单
        let stu = localStorage.getItem("userInfo");
        if (stu) {
            let obj = JSON.parse(stu);
            if (obj) {
                me.$store.commit('SET_PERMS', obj.main == 1);
            }
        }

        me.getNotify();
        me.interval = setInterval(function() { me.getNotify() }, 10000);

           let netName = localStorage.netName;
            if (netName == undefined) {
                localStorage.setItem("netName", "国内线路");

            }

    },
    beforeRouteLeave(to, from, next) {

        if (to.name == "Login" && this.interval) {
            window.clearInterval(this.interval);

        }


        next();
    },
    beforeRouteUpdate(to, from, next) {



        next();
    },
    beforeRouteEnter(to, from, next) {

        next();
    },
    create: function() {
        this.$store.commit('setOpenedList');
    },
    watch: {
        '$route'(to) {

            this.$store.commit('setCurrentPageName', to.name);

            let pathArr = util.setCurrentPath(this, to.name);
            if (pathArr.length > 2) {
                this.$store.commit('addOpenSubmenu', pathArr[1].name);
            }
            this.checkTag(to.name);
            localStorage.currentPageName = to.name;
        }
    },
    methods: {
        beforePush(name) {
            // if (name === 'accesstest_index') {
            //     return false;
            // } else {
            //     return true;
            // }
            return true;
        },
        checkTag(name) {
            let openpageHasTag = this.pageTagsList.some(item => {
                if (item.name === name) {
                    return true;
                }
            });
            if (!openpageHasTag) { //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
                util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {});
            }
        },
        toggleClick() {
            this.shrink = !this.shrink;
        },
        waybillGo: function() {
            this.$router.push({ name: 'WaybillOutgo' });
        },
        waybillLocalGo: function() {
            this.$router.push({ name: 'WaybillLocalOutgo' });

        },
        waybillLocalSignGo: function() {
            this.$router.push({ name: 'WaybillLocalSign' });

        },
        BillSign:function(){
            this.$router.push({ name: 'BillSign' });
        },
        waybillExpressGo: function() {
            this.$router.push({ name: 'WaybillExpressOutgo' });
        },
        getNotify: function() {
            var me = this;
            let token = localStorage.getItem('token');

            if (token == "" || token == undefined) {
                return;
            }
            me.$http.post('/ware/stastis/notify.action').then(response => {
                if (response.status == 0) {
                    var counts = response.obj;

                    me.$store
                        .dispatch("setCount", counts);

 me.$refs['cpMenu'].billCount = counts.billCount + counts.billCountBack + counts.billCountSign;
                    me.$refs['cpMenu'].waybillExpressCount = counts.toPackageSignCount;
                    me.$refs['cpMenu'].waybillCount = counts.toSignCount + counts.toOutgoingCount;
                    me.$refs['cpMenu'].toSignCount = counts.toSignCount;
                    me.$refs['cpMenu'].toOutgoingCount = counts.toOutgoingCount;
                    me.$refs['cpMenu'].expressBackCount=counts.expressBackCount;
                    var allall = counts.waybillExpressCount + counts.waybillCount;
                    if (allall > 0)
                        iNotify.setFavicon(allall).setTitle('有新的订单，未处理啦').notify({
                            title: "新通知",
                            body: "有新的订单，未处理啦"
                        });
                    else {
                        iNotify.setFavicon(allall).setTitle('')
                    }
                } else {

                }

            }).catch(response => {

            });

        }
    }
}
</script>
<style scoped>
.layout {}
</style>